import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 先检查是否已经 开通记账本
export function checkAlipayAccount (params?: {
  currencyCode: string // 币种
}): Promise<{
  code: string
  data: string
  msg: string
  state: string
  success: boolean
}> {
  return request(`/saas/gtpw/alipaysafe/checkAlipayAccount?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 签约接口
export function pageSign (params?: {
  currencyCode: string // 币种
}): Promise<{
  code: string
  data: string
  msg: string
  state: string
  success: boolean
}> {
  return request(`/saas/gtpw/alipaysafe/pageSign?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 签约查询接口
export function signQuery (): Promise<{
  code: string
  data: string
  msg: string
  state: string
  success: boolean
}> {
  return request('/saas/gtpw/alipaysafe/signQuery', {
    method: 'POST'
  })
}

// 判断余额是否够,不够获取支付链接
export function pagePay (params: {
  accountBookId: string // 记账本id
  code: string // 金额收取渠道
  currencyCode: string // 币种
  money: string // 金额
}): Promise<{
  code: string
  data?: {
    codeImgUrl: string
    codeUrl: string
    fee: string
    msg: string
    orderId: string
    success: 'true' | 'false'
  },
  msg: string
  state: string
  success: boolean
}> {
  return request(`/saas/gtpw/alipaysafe/pagePay?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 轮询记账本金额是否够
export function getAccountBalance (params: {
  accountBookId: string // 记账本id
  code: string // 金额收取渠道
  currencyCode: string // 币种
  money: string // 金额
}): Promise<{
  code: string
  data: string
  msg: string
  state: string
  success: boolean
}> {
  return request(`/saas/gtpw/alipaysafe/getAccountBalance?${formatParam(params)}`, {
    method: 'POST'
  })
}
